(function (angular) {
    'use strict';

    angular.module('integration')
        /**
         *
         */
        .controller('webhooksCtrl',
            ['$scope', 'webhooksService', 'useBatch', 'canDisable', '$stateParams', 'sweetAlertService', 'growlService', 'webhooksData', 'integrationModalHelperService', '$sanitize',
                function ($scope, webhooksService, useBatch, canDisable, $stateParams, sweetAlertService, growlService, webhooksData, integrationModalHelperService, $sanitize) {

                    $scope.webhooksData = webhooksData;
                    $scope.webhooksData.forEach(element => {
                        element.isEnabled = element._disabledOn === undefined;
                    });
                    $scope.useBatch = useBatch;
                    $scope.canDisable = canDisable || $stateParams.allowDisable === "true";

                    let hideCoreDefaultWebhooks = $stateParams.showCoreDefault !== "true";

                    $scope.deleteWebhook = function (webhook) {
                        sweetAlertService.confirmationAlert(
                            "Are you sure?",
                            "Are you sure you want to remove " + webhook.name + "?",
                            "Remove",
                            "Cancel",
                            function (isConfirmed) {
                                if (isConfirmed) {
                                    webhooksService.deleteWebhook($stateParams.pickedApiSpaceId, webhook.id).then(function (ret) {
                                        growlService.success('Webhook deleted');
                                        var index = $scope.webhooksData.indexOf(webhook);
                                        $scope.webhooksData.splice(index, 1);
                                    }).catch(function (error) {
                                        growlService.danger("Webhook wasn't deleted due to: " + error.statusText);
                                    });
                                }
                            }
                        );

                    };

                    /**
                     * @param{object} webhook - optional webhook to update
                     */
                    function launchWebhookModal(webhook) {
                        $scope.modalInstance = integrationModalHelperService.openWebhookModal(webhook, useBatch);

                        return $scope.modalInstance.result.then(function (data) {

                            if (data.id) {
                                return webhooksService.updateWebhook($stateParams.pickedApiSpaceId, data)
                                    .then(function (result) {
                                        growlService.success('Webhook updated');
                                        var index = $scope.webhooksData.indexOf(webhook);
                                        result.isEnabled = result._disabledOn === undefined;
                                        $scope.webhooksData[index] = result;
                                        return result;
                                    }).catch(function (error) {
                                        growlService.danger("Webhook wasn't updated due to: " + error.statusText);
                                    });

                            } else {
                                return webhooksService.createWebhook($stateParams.pickedApiSpaceId, data)
                                    .then(function (result) {
                                        growlService.success('Webhook created');
                                        result.isEnabled = true;
                                        $scope.webhooksData.push(result);
                                        return result;
                                    }).catch(function (error) {
                                        growlService.danger("Webhook wasn't created due to: " + error.statusText);
                                    });
                            }

                        });
                    }

                    /**
                     * This method is called off the back of toggling the switch so the backend needs to be synced with 
                     * the current switch state (ir the switch reverting if there is an error)
                     * @param {*} webhook 
                     * @returns 
                     */
                    $scope.toggleEnabled = function (webhook) {
                        if (!webhook.isEnabled) {
                            return webhooksService.disableWebhook($stateParams.pickedApiSpaceId, webhook.id)
                                .then(function (result) {
                                    growlService.success('Webhook disabled');
                                    return result;
                                })
                                .catch(function (error) {
                                    growlService.danger("Webhook wasn't disabled due to: " + error.statusText);
                                    webhook.isEnabled = true;
                                });
                        } else {
                            return webhooksService.enableWebhook($stateParams.pickedApiSpaceId, webhook.id)
                                .then(function (result) {
                                    growlService.success('Webhook enabled');
                                    return result;
                                })
                                .catch(function (error) {
                                    growlService.danger("Webhook wasn't enabled due to: " + error.statusText);
                                    webhook.isEnabled = false;
                                });
                        }
                    }

                    $scope.createWebhook = function () {
                        return launchWebhookModal();
                    }

                    $scope.editWebhook = function (webhook) {
                        return launchWebhookModal(webhook);
                    }
                    $scope.sanitize = $sanitize;

                    $scope.showWebhook = function (webhook) {
                        if (hideCoreDefaultWebhooks) {
                            let isCore = webhook.url !== undefined && (webhook.url.includes("ddlnk.net") || webhook.url.includes("debug-tracking.dotdigital.internal")) && webhook.id === "Default_Webhook";
                            return !isCore;
                        } else {
                            return true;
                        }
                    }

                }]);

})(window.angular);
